import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Welcome from './pages/Welcome';
import Home from './pages/Home';
import TicketDesign from './pages/TicketDesign';
import Payment from './pages/Payment';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentProcessing from './pages/PaymentProcessing';
import PaymentFailed from './pages/PaymentFailed';
import PayRemaining from './pages/PayRemaining';
import AdminPanel from './pages/AdminPanel';
import BookingBase from './components/BookingBase';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import BookingsManagement from './pages/BookingsManagement';
import PagesManagement from './pages/PagesManagement';
import EmailManagement from './pages/EmailManagement';
import CalendarManagement from './pages/CalendarManagement';
import AdminCalendar from './pages/AdminCalendar';
import CityManagement from './pages/CityManagement';
import PromoCodesManagement from './pages/PromoCodesManagement';
import InvoicesManagement from './pages/InvoicesManagementFixed';
import ProtectedRoute from './components/ProtectedRoute';
import ConfirmedBookings from './pages/ConfirmedBookings';
import PassPage from './pages/PassPage';
import AdditionalPayment from './pages/AdditionalPayment';
import AdditionalPaymentSuccess from './pages/AdditionalPaymentSuccess';
import CheckTicketStatus from './pages/CheckTicketStatus';
import TicketStatus from './pages/TicketStatus';
import ViewTickets from './pages/ViewTickets';
import ContactUs from './pages/ContactUs';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TamaraCallback from './pages/TamaraCallback';
import BookingDynamic from './pages/BookingDynamic';
import DimensionsDynamic from './pages/DimensionsDynamic';
import StaffBookingForm from './pages/StaffBookingForm';
import './App.css';

function App() {
  // منع النقر الأيمن
  React.useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      // منع Ctrl+A, Ctrl+C, Ctrl+X
      if (e.ctrlKey && (e.key === 'a' || e.key === 'c' || e.key === 'x')) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Welcome />} />
      <Route path="/home" element={<Home />} />
      <Route path="/dimensions/:slug" element={<DimensionsDynamic />} />
      <Route path="/booking/:slug" element={<BookingDynamic />} />
      <Route path="/ticket-design" element={<TicketDesign />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-processing" element={<PaymentProcessing />} />
      <Route path="/payment-failed" element={<PaymentFailed />} />
      <Route path="/pay-remaining/:bookingId" element={<PayRemaining />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={
        <ProtectedRoute>
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/admin-panel" element={
        <ProtectedRoute>
          <AdminPanel />
        </ProtectedRoute>
      } />
      <Route path="/admin/bookings-management" element={
        <ProtectedRoute>
          <BookingsManagement />
        </ProtectedRoute>
      } />
      <Route path="/admin/pages-management" element={
        <ProtectedRoute>
          <PagesManagement />
        </ProtectedRoute>
      } />
      <Route path="/admin/email-management" element={
        <ProtectedRoute>
          <EmailManagement />
        </ProtectedRoute>
      } />
      <Route path="/admin/calendar-view" element={
        <ProtectedRoute>
          <AdminCalendar />
        </ProtectedRoute>
      } />
      <Route path="/admin/calendar-management" element={
        <ProtectedRoute>
          <CalendarManagement />
        </ProtectedRoute>
      } />
      <Route path="/admin/cities-management" element={
        <ProtectedRoute>
          <CityManagement />
        </ProtectedRoute>
      } />
      <Route path="/admin/promo-codes" element={
        <ProtectedRoute>
          <PromoCodesManagement />
        </ProtectedRoute>
      } />
      <Route path="/admin/invoices" element={
        <ProtectedRoute>
          <InvoicesManagement />
        </ProtectedRoute>
      } />
      <Route path="/admin/confirmed-bookings" element={
        <ProtectedRoute>
          <ConfirmedBookings />
        </ProtectedRoute>
      } />
      <Route path="/pass/:bookingCode" element={
        <ProtectedRoute>
          <PassPage />
        </ProtectedRoute>
      } />
      <Route path="/additional-payment/:bookingId" element={<AdditionalPayment />} />
      <Route path="/additional-payment-success/:bookingId/:ticketCount" element={<AdditionalPaymentSuccess />} />
      <Route path="/check-ticket-status" element={<CheckTicketStatus />} />
      <Route path="/ticket-status" element={<TicketStatus />} />
      <Route path="/tickets/:bookingCode" element={<ViewTickets />} />
      <Route path="/view-tickets/:bookingId" element={<ViewTickets />} />
      <Route path="/design-your-tickets/:bookingCode" element={<TicketDesign />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/tamara-callback" element={<TamaraCallback />} />
      <Route path="/form" element={<StaffBookingForm />} />
    </Routes>
  );
}

export default App;
